import { DARK_LAUNCH_KEYS, contentIntelligenceDarkLaunch } from './titleDarkLaunch';

export const normalizeTitleType = (value) => (value === 'tv' ? 'series' : (value || 'movie'));
export const contentIntelligenceEnabled = process.env.REACT_APP_CONTENT_INTELLIGENCE_ENABLED !== 'false';

export const contentIntelligenceAvailableFor = (title) => {
  if (!contentIntelligenceEnabled) return false;
  if (!contentIntelligenceDarkLaunch) return true;
  const type = normalizeTitleType(title?.type);
  const id = title?.tmdb_id || title?.id;
  return DARK_LAUNCH_KEYS.has(`tmdb:${type}:${id}`);
};

export const slugifyTitle = (value) => (value || 'title')
  .toLowerCase()
  .normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-|-$/g, '')
  .slice(0, 80) || 'title';

export const titleIntelligencePath = (title) => {
  const type = normalizeTitleType(title?.type);
  const id = title?.tmdb_id || title?.id;
  return `/title/${type}/${id}/${slugifyTitle(title?.title || title?.name)}`;
};
